/** HCEN plan presets — role login quotas per hospital tier. */

export const STAFF_ROLES = [
  { id: 'manager', label: 'Manager / Owner', description: 'Hospital admin — creates staff logins' },
  { id: 'doctor', label: 'Doctors', description: 'OPD queue, EMR, consultations' },
  { id: 'reception', label: 'Reception', description: 'OP queue, patient registration' },
  { id: 'billing', label: 'Billing', description: 'Receipts and payments' },
  { id: 'ipd', label: 'IPD Coordinator', description: 'Admissions and beds' },
  { id: 'nurse', label: 'Nurses', description: 'Nursing station, IP care' },
  { id: 'pharmacy', label: 'Pharmacy', description: 'Medicine dispensing' },
  { id: 'lab', label: 'Laboratory', description: 'Lab orders and results' },
  { id: 'hr', label: 'HR', description: 'People and records' },
  { id: 'housekeeping', label: 'Housekeeping', description: 'Room cleaning, linen, disinfection' },
];

export const PLAN_PRESETS = {
  Basic: {
    label: 'Basic',
    description: 'Clinic / small nursing home',
    modules: ['op', 'billing', 'patients'],
    roleLimits: {
      manager: 2, doctor: 10, reception: 3, billing: 2, ipd: 2, nurse: 3, pharmacy: 2, lab: 2, hr: 1, housekeeping: 2,
    },
    pricing: { monthlyFee: 2999, opConsultFee: 300, generalBedRate: 1200, privateBedRate: 2500, icuBedRate: 6000 },
  },
  Standard: {
    label: 'Standard',
    description: 'Medium hospital — full OP + IP',
    modules: ['op', 'ipd', 'emr', 'pharmacy', 'lab', 'billing'],
    roleLimits: {
      manager: 3, doctor: 30, reception: 6, billing: 4, ipd: 5, nurse: 10, pharmacy: 3, lab: 3, hr: 2, housekeeping: 4,
    },
    pricing: { monthlyFee: 7999, opConsultFee: 500, generalBedRate: 1500, privateBedRate: 3000, icuBedRate: 8500 },
  },
  Premium: {
    label: 'Premium',
    description: 'Large multi-specialty hospital',
    modules: ['op', 'ipd', 'emr', 'pharmacy', 'lab', 'billing', 'hr', 'analytics'],
    roleLimits: {
      manager: 5, doctor: 100, reception: 15, billing: 8, ipd: 10, nurse: 30, pharmacy: 6, lab: 6, hr: 3, housekeeping: 8,
    },
    pricing: { monthlyFee: 19999, opConsultFee: 750, generalBedRate: 2000, privateBedRate: 4500, icuBedRate: 12000 },
  },
  Enterprise: {
    label: 'Enterprise',
    description: 'Hospital chains — custom scale',
    modules: ['op', 'ipd', 'emr', 'pharmacy', 'lab', 'billing', 'hr', 'analytics'],
    roleLimits: {
      manager: 10, doctor: 500, reception: 50, billing: 20, ipd: 25, nurse: 80, pharmacy: 15, lab: 15, hr: 10, housekeeping: 20,
    },
    pricing: { monthlyFee: 49999, opConsultFee: 1000, generalBedRate: 2500, privateBedRate: 6000, icuBedRate: 15000 },
  },
};

export const ALL_MODULES = [
  { id: 'op', label: 'OP / Queue' },
  { id: 'patients', label: 'Patients' },
  { id: 'billing', label: 'Billing' },
  { id: 'emr', label: 'EMR' },
  { id: 'ipd', label: 'IPD' },
  { id: 'pharmacy', label: 'Pharmacy' },
  { id: 'lab', label: 'Laboratory' },
  { id: 'hr', label: 'HR' },
  { id: 'analytics', label: 'Analytics' },
];

export function totalRoleLimit(roleLimits) {
  return Object.values(roleLimits || {}).reduce((s, n) => s + Number(n || 0), 0);
}

export function roleLimitsForPlan(plan) {
  return { ...(PLAN_PRESETS[plan]?.roleLimits || PLAN_PRESETS.Basic.roleLimits) };
}

export function modulesForPlan(plan) {
  return [...(PLAN_PRESETS[plan]?.modules || PLAN_PRESETS.Basic.modules)];
}

export function pricingForPlan(plan) {
  return { ...(PLAN_PRESETS[plan]?.pricing || PLAN_PRESETS.Basic.pricing) };
}

export function slugFromName(name) {
  return (name || 'hospital')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '')
    .slice(0, 24) || 'hospital';
}
